import styles from './style.styl'
import { Big } from '../text'

const ApplyButton = () => {
  const scrollToSection = (id) => {
    const section = document.getElementById(id)
    const { top } = section.getBoundingClientRect()
    window.scrollTo({ top: top + window.scrollY, behavior: 'smooth' })
  }

  return (
    <div className={styles.apply}>
      <button className={styles.button} onClick={() => scrollToSection('apply')}>
        <Big as={'span'}>Apply now</Big>
      </button>
    </div>
  )
}

export default ApplyButton



// WEBPACK FOOTER //
// ./components/apply-button/index.js